import View from '@/components/atomic/atoms/layout/view/styled';
import styled, { CSSObject } from '@emotion/styled';

const Backdrop = styled(View)(({ theme }) => {
	const style: CSSObject = {
		backgroundColor: theme.colors.secondaryBrandColor,
		position: 'absolute',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		borderRadius: 15,
		opacity: 0.5,
	};

	return style;
});

export default Backdrop;
